export default function getResource(label, vars = []) {
    const resources = {
        pageHeading: 'Share your discount',
        counterCount: `${vars[0]} of ${vars[1]}`,
        counterClaimedLabel: 'promo codes claimed',
        shareCta: 'Share',
        copy: 'Copy',
        copied: 'Copied',
        limitReachedHeading: 'You’ve shared all your codes',
        limitReachedBody: 'You’ve reached your sharing limit. Explore these offers picked for you.',
        offersTitle: 'Beauty Offers',
        signInPrompt: 'Sign in to share your discount',
        signIn: 'Sign In',
        createAccount: 'Create Account',
        counterLoading: 'Loading your promo codes…',
        counterError: 'We couldn’t load your promo codes. Please try again.',
        retry: 'Try Again'
    };

    return resources[label];
}
